<template>
  <div class="button" :class="[`size_${size} button_${type}`, { disabled, loading }]" v-on="$listeners">
    <template v-if="leftIcon && !loading">
      <Icon :name="leftIcon" />
    </template>

    <div v-if="$slots.default" class="text">
      <slot v-if="!loading" />
    </div>

    <template v-if="rightIcon && !loading">
      <Icon :name="rightIcon" />
    </template>

    <Icon class="button__refresh-icon" v-if="loading" type="solid" name="refresh" />
  </div>
</template>
<script>
import Icon from '@/components/Base/Icon/Icon.vue'

export default {
  name: 'Button',
  props: {
    leftIcon: {
      value: String,
      default: ''
    },
    rightIcon: {
      value: String,
      default: ''
    },
    disabled: {
      value: Boolean,
      default: false
    },
    loading: {
      value: Boolean,
      default: false
    },
    size: {
      value: String,
      default: 'lg',
      validator: function(value) {
        return ['xl', 'lg', 'md', 'sm'].includes(value)
      }
    },
    type: {
      value: String,
      default: 'primary',
      validator: function(value) {
        return ['secondary', 'primary'].includes(value)
      }
    }
  },
  components: { Icon }
}
</script>
<style lang="scss">
@import './button';
</style>
